import { base } from "@base-provider";
import { API_PARAM } from "../constants/apiParams";
import { sanitizeFileName } from "@sf-core";
import { ExportFileNames } from "../constants/exportFileNames";


export const getBenchmarkSkillsCount = async () => {
  return base.get({
    url: `${API_PARAM.BENCHMARK_SKILLS_COUNT}`,
  });
};

export const exportBenchmarkSkillsGrid = async (filterModel) => {
  return base.exportFile({
    url: API_PARAM.BENCHMARK_SKILLS_EXPORT,
    data: filterModel,
    fileName: sanitizeFileName(ExportFileNames.BENCHMARK_SKILLS),    
  });
};

export const uploadBenchmarkSkills = async () => {
  return base.post({
    url: `${API_PARAM.BENCHMARK_SKILLS_UPLOAD}`,
  });
};